import { DescrittoreSezione } from './descrittore-sezione';

export abstract class CtxBodyAbstract {
  descrittori: DescrittoreSezione[];

  constructor(descrittori: DescrittoreSezione[]) {
    this.descrittori = descrittori;
  }
}
